const PAID_FEEDBACK_HINT_SHOWN_KEY = 'paidFeedbackHintShown.v2';

export const PAID_FEEDBACK_HINT_EVENT = 'paidFeedbackHintChanged';

function hasShownPaidFeedbackHint(): boolean {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem(PAID_FEEDBACK_HINT_SHOWN_KEY) === 'true';
}

/**
 * Mark the paid-feedback hint as shown and notify other components to display it.
 * Called when user closes the paid-feedback modal. No-op if it has already been shown.
 */
export function triggerPaidFeedbackHint(): void {
  if (typeof window === 'undefined') return;

  const shouldShow = !hasShownPaidFeedbackHint();

  if (shouldShow) {
    window.dispatchEvent(new CustomEvent(PAID_FEEDBACK_HINT_EVENT, { detail: shouldShow }));
    localStorage.setItem(PAID_FEEDBACK_HINT_SHOWN_KEY, 'true');
  }
}
